<!-- 物料卡 -->
<template>
  <div class="product-card">
    <div class="card-name">{{ datas[name] }}</div>
    <div class="card-specs">规格：{{ datas[desc] }}</div>
    <div class="card-price">售价：{{ datas[price] }}</div>
    <van-stepper class="card-number" v-model="datas.number" integer input-width="40px" button-size="32px" min="0" />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: 0,
    },
    name: {
      type: String,
      default: 'name',
    },
    desc: {
      type: String,
      default: 'desc',
    },
    price: {
      type: String,
      default: 'price',
    },
    datas: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      cardValue: 0,
    }
  },
  watch: {
    value(val) {
      this.cardValue = val
    },
    'datas.number'(val) {
      this.$emit('input', val)
      this.$emit('change', { ...this.datas, number: val })
    },
  },
}
</script>

<style lang="less" scoped>
.product-card {
  width: 100%;
  border-bottom: 1px solid #ededed;
  padding-left: 20px;
  position: relative;
  .card-name {
    font-size: 14px;
    line-height: 40px;
  }
  .card-specs {
    font-size: 12px;
    color: #a6a6a6;
    // line-height: 50px;
  }
  .card-price {
    font-size: 12px;
    line-height: 40px;
    color: #e1514c;
  }
  .card-number {
    position: absolute;
    right: 20px;
    top: 30px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/ProductCard.vue